import { render, staticRenderFns } from "./AllUsersComments.vue?vue&type=template&id=4819ff52&scoped=true&"
import script from "./AllUsersComments.vue?vue&type=script&lang=js&"
export * from "./AllUsersComments.vue?vue&type=script&lang=js&"
import style0 from "./AllUsersComments.vue?vue&type=style&index=0&id=4819ff52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819ff52",
  null
  
)

export default component.exports